import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewExpenses_ProjectionModal (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [checkInModal, setCheckInModal] = useState(false);

    let [viewExpenses, setViewExpenses] = useState([]);



    useEffect(() => {

        //alert('Inside USEEFFECT ViewAvailableRoomsModal');

        if(props.openModal == true)
        {

            /*
            let formData = new FormData();
            formData.append('Tracker', '74002A_P');
            formData.append('user', acctID);
            formData.append('xStartDateRange', startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', endDate.toISOString().substr(0, 10));
                

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_P',
                    user: acctID,
                    xStartDateRange: props.startDate.toISOString().substr(0, 10),
                    xEndDateRange: props.endDate.toISOString().substr(0, 10),
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    //alert(cols.length);
                    //alert(viewInventoryAvailableRooms);



                    setViewExpenses((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            expenseID: cols[0],
                            supplierName: cols[1],
                            supplierPhoneNumber: cols[2],
                            expenseDescription: cols[3],
                            dateLogged: cols[4],
                            unitAmount: cols[5],
                            quantity: cols[6],
                            totalAmount: cols[7],
                            paymentType: cols[8],
                            attachment: cols[9],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        setViewExpenses([]);
        props.closeModal(event);
    }
 
    function viewExpenseInvoiceHandler(event) {

        setCheckInModal(event[0]);
        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }
    //alert('Inside ViewAvailableRooms');
    //alert(props.openModal);
    //alert(openModal);

    return (

        <React.Fragment>            
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonText> One-Time Expenses </IonText>
                    <IonGrid class='appGridContent'>
                        <IonRow >
                                <IonCol >Supplier Name</IonCol>
                                <IonCol >Supplier Phone</IonCol>
                                <IonCol >Expense Description</IonCol>
                                <IonCol >Date Logged</IonCol>
                                <IonCol >Total Amount</IonCol>                                        
                                <IonCol >Action</IonCol>
                        </IonRow>
                        {viewExpenses.map((detailData) =>   {
                            return (
                                <IonRow key={detailData.expenseID}>
                                    <IonCol >{detailData.supplierName}</IonCol>
                                    <IonCol >{detailData.supplierPhoneNumber}</IonCol>
                                    <IonCol >{detailData.expenseDescription}</IonCol>
                                    <IonCol >{detailData.dateLogged}</IonCol>
                                    <IonCol >{detailData.totalAmount}</IonCol>
                                    <IonCol >
                                        <IonButton onClick={() => viewExpenseInvoiceHandler([detailData.unitAmount, detailData.quantity, detailData.totalAmount, detailData.paymentType])}> View Invoice</IonButton>
                                    </IonCol>
                                </IonRow>
                            )
                        }
                        )}
                    </IonGrid>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={closeModalHandler}> Close </IonButton>
                    </IonFooter>
                </IonModal>            
            </div>
            ) : null }
        </React.Fragment>

    )
}